import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { RouterModule } from '@angular/router';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MSAL_INSTANCE, MsalBroadcastService, MsalGuard, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { OAuthComponent } from '@app/components/oauth/oauth.component';

export function initializeMsalInstance(): PublicClientApplication {
  try {
  return new PublicClientApplication({
    auth: {
      clientId: '8e53b699-da2f-45f3-af9c-e2f57247eb1f', // Application (client) ID from Azure
      authority: 'https://login.microsoftonline.com/caf9409b-aea9-4c50-9e55-df3168e24fcf', // Directory (tenant) ID from Azure
      redirectUri: 'http://localhost:4200', // Sama kuin rekisteröity redirect URI
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false, // Voit vaihtaa true, jos käytät IE11:tä
    }
  });
  } catch (error) {
    console.error(error);
    return null;
  }
}

@NgModule({
  declarations: [
    OAuthComponent
  ],
  imports: [
    MsalModule.forRoot(initializeMsalInstance(), {
      interactionType: InteractionType.Popup,
      authRequest: {
        scopes: ['User.Read', 'offline_access']
      }
    },{
        interactionType: InteractionType.Popup,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['User.Read', 'Mail.Read', 'offline_access']]
        ])
      }
    ),
    SharedModule,
    RouterModule,
  ],
  exports: [
    OAuthComponent
  ],
  providers: [MsalGuard],
  bootstrap: [MsalRedirectComponent]
})
export class OAuthModule { }
